/* eslint-disable */
<template>
  <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <h2 class="titleMobile">{{ $t('views.mySubscriptions.title') }}</h2>
      <div class="plantillaSuscrip">
        <!-- LINK -->
        <v-row class="mt-4">
          <v-col cols="12">
            <p class="msg__download">{{ $t('views.mySubscriptions.view.msgTitle1') }}
              <b>{{ $t('views.mySubscriptions.view.msgTitleBold') }}</b>
              {{ $t('views.mySubscriptions.view.msgTitle2') }}
              <span v-if="!isAppInstalled && !isMobile">
                {{ $t('views.mySubscriptions.view.msgTitleQR') }}
              </span>
            </p>
          </v-col>
        </v-row>
        <!-- QR si el usuario no tiene la app movil descargada -->
        <div v-if="!isAppInstalled && !isMobile">
          <div
          :style="{display: 'flex', gap: '2rem', margin: '1rem 2rem'}">
            <div
            :style="{display: 'flex', flexDirection:'column'}">
              <img
                alt="QR Android"
                src="@/assets/QR_PlayStore.jpg"
                contain
                width="90"
              />
              <img
                alt="Android"
                src="@/assets/logo_badge_googlePlay.png"
                contain
                width="90"
              />
            </div>
            <div
            :style="{display: 'flex', flexDirection:'column'}">
              <img
                alt="QR IOS"
                src="@/assets/QR_AppStore.png"
                contain
                width="90"
              />
              <img
                alt="iOS"
                src="@/assets/logo_badge_appStore.png"
                contain
                width="90"
              />
            </div>
          </div>
        </div>
        <!-- STOP NOTIFICATIONS -->
        <v-row>
          <v-col>
            <StopMobileNotifications/>
          </v-col>
        </v-row>

        <!-- FORM AND FILTERS -->
        <v-row class="plantillaChips">
          <v-col cols="12">
            <!-- SEARCH -->
            <v-col cols="12">
              <div class="container_form">
                <v-text-field
                  class="inputSearch"
                  label="Aplicación"
                  prepend-icon="mdi-magnify"
                  v-model="textInput"
                  @keyup="changeInput"
                >
                </v-text-field>
              </div>
            </v-col>
            <!-- CHIP -->
            <v-sheet class="showWeb mb-5 mt-1">
              <div class="container__chip">
                <span
                  v-for="group in groupingsAppList"
                  :key="group.uuid"
                  :class="[group.active ? 'chip__active' :
                    '', 'chip__agrupaciones chip__filter v-chip']"
                >
                  <div class="chipMenu">
                    <span @click="clickFilterGroup({ name: group.nombre })">
                      {{ group.nombre}}
                    </span>
                    <v-menu >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon density="compact" variant="text" v-on="on"
                        >
                          <v-icon @click="showOptions({ nombre: group.nombre })"
                            class="iconChips" v-on="on"
                          >
                            {{
                              findOptions({ nombre: group.nombre }) ?
                                'mdi-chevron-up' :
                                'mdi-chevron-down'
                            }}
                          </v-icon>
                      </v-btn>
                      <!-- CONDICIONAR EL FILTRO TODOS PARA NO MOSTRAR EL MENU -->
                      </template>
                      <v-list class="listSheet">
                        <v-list-item
                          :key="`suscribir${group.uuid}`"
                          link
                          class="listSheetItem"
                          @click="clickAddGroup(
                            {
                              groupId: group.uuid,
                              nombre: group.nombre
                            }
                          )"
                        >
                          <v-list-item-title class="listSheetTitle">
                            Suscribir
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                          :key="`desuscribir${group.uuid}`"
                          link
                          class="listSheetItem"
                          @click="clickDeleteGroup(
                            {
                              groupId: group.uuid,
                              nombre: group.nombre,
                            }
                          )"
                        >
                          <v-list-item-title class="listSheetTitle">
                            Desuscribir
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </span>
              </div>
            </v-sheet>

            <v-col cols="showMobile">
              <FiltersSlide
                v-if="showFilters"
                :isBadge="isBadge"
                :isSubscription="isSubscription"
                :filters="filtersInitialMySubscription"
                :selectedFilters="filtersMySubscription"
                @filter-selected="filterSearch"
              >
                <!-- Slot personalizado -->
                <template v-slot="{ filter }">
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon density="compact" variant="text" v-on="on"
                      >
                        <v-icon @click="showOptions({ nombre: filter.text })"
                          class="iconChips" v-on="on"
                        >
                          {{
                            findOptions({ nombre: filter.text }) ?
                              'mdi-chevron-up' :
                              'mdi-chevron-down'
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list class="listSheet">
                      <v-list-item
                        :key="`suscribir${filter.uuid}`"
                        link
                        class="listSheetItem"
                        @click="clickAddGroup(
                          {
                            groupId: filter.groupId,
                            nombre: filter.text
                          }
                        )"
                      >
                        <v-list-item-title class="listSheetTitle">
                          Suscribir
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        :key="`desuscribir${filter.uuid}`"
                        link
                        class="listSheetItem"
                        @click="clickDeleteGroup(
                          {
                            groupId: filter.groupId,
                            nombre: filter.text,
                          }
                        )"
                      >
                        <v-list-item-title class="listSheetTitle">
                          Desuscribir
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </FiltersSlide>
            </v-col>
          </v-col>
        </v-row>

        <!-- CARD -->
        <template>
          <div>
            <!-- ERROR -->
            <v-row v-if="errorSuscripciones">
              <v-col cols="12">
                <p
                  class="msgErrorSuscripciones">
                  {{ msgErrorSuscripciones }}
                </p>
              </v-col>
            </v-row>

            <!-- LOADING -->
            <div v-if="loadingSubscriptions" class="loadingProgress">
              <v-progress-circular
                class="primary--text"
                :style="{marginLeft: '2rem'}"
                indeterminate
              ></v-progress-circular>
            </div>

            <!-- CARD SUSCRIPCIONES -->
            <div v-if="!loadingSubscriptions" class="d-flex flex-wrap">
              <template>
                  <template v-for="group in groupingsAppList">
                    <template v-if="group.active">
                      <template v-for="application in group.children">
                        <v-card
                          :key="application.uuid"
                          class="mx-5 mb-5 card__aplicacion d-flex card justify-space-between"
                          max-width="420"
                        >
                          <v-card-title class="cardTitle">{{ application.nombre }}</v-card-title>
                          <v-card-actions>
                            <v-switch
                              v-model="application.suscrito"
                              @click="clickSwitchActivateApplication({
                                groupId: application.agrupacion.uuid,
                                nombre: application.nombre,
                                applicationId: application.uuid,
                                isSubscriber: application.suscrito,
                              })"
                            ></v-switch>
                          </v-card-actions>
                        </v-card>
                      </template>
                    </template>
                  </template>
              </template>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState, mapGetters } from 'vuex';
import { StopMobileNotifications, FiltersSlide } from '@/components';

export default {
  name: 'MySubscriptions',
  components: { StopMobileNotifications, FiltersSlide },
  data() {
    return {
      isBadge: false,
      isSubscription: true,
      loading: false,
      showFilters: false,
      loadingSubscriptions: true,
      errorSuscripciones: false,
      name: '',
      textInput: '',
      msgErrorSuscripciones: '',
      titleAllGroups: 'Todo',
      showMenuGroup: null,
      groupingsAppList: [],
      groupingsAppListAux: [],
      applicationsAppList: [],
      stringSubscriptions: 'Todo',
      showMenuOptions: [],
      dataLabel: false,
      isAppInstalled: true,
      filtersInitialMySubscription: [],
      filtersMySubscription: [],
      isLinkBanner: false,
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    color() {
      // eslint-disable-next-line no-bitwise
      const hash = this.user.fullName
        .split('')
        .reduce((tot, curr) => curr.charCodeAt(0) + ((tot < 5) - tot), 0);
      return Array.from({ length: 3 }, (_, i) => i).reduce((acum, idx) => {
        // eslint-disable-next-line no-bitwise
        const val = (hash >> (idx * 8)) & 0xff;
        return acum + `00${val.toString(16)}`.substr(-2);
      }, '#');
    },
    openPanel() {
      return 0;
    },
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
  },
  props: {
    applications: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClickOutside() {
      const buttons = document.querySelectorAll('button.v-icon');
      buttons.forEach((button) => {
        button.classList.remove('mdi-chevron-up');
        button.classList.add('mdi-chevron-down');
      });
      this.showMenuGroup = null;
    },
    showOptions({ nombre }) {
      this.clickFilterGroup({ name: nombre });
      this.showMenuGroup = nombre;
    },
    findOptions({ nombre }) {
      return nombre === this.showMenuGroup;
    },
    changeInput(e) {
      this.filtersMySubscription = [];
      this.filtersMySubscription.push(this.titleAllGroups);

      const applicationName = e.target.value;

      this.groupingsAppList = this.groupingsAppListAux;

      if (applicationName !== '') {
        this.groupingsAppList = this.groupingsAppList.map((group, index) => {
          const filteredChildren = applicationName
            ? group.children.filter((child) => child.nombre
              .toLowerCase()
              .includes(applicationName.toLowerCase()))
            : group.children;
          const isActive = index === 0;

          return {
            ...group,
            active: isActive,
            children: filteredChildren,
          };
        });
      }
    },
    clickFilterGroup({ name }) {
      this.filtersMySubscription = [];

      this.groupingsAppList = this.groupingsAppListAux;
      this.groupingsAppList.forEach((group) => {
        group.active = group.nombre === name;
      });

      this.filtersMySubscription.push(name);
    },
    filterSearch(data) {
      const { text } = data;
      this.clickFilterGroup({ name: text });
    },

    //
    async addSubscriptionsAll() {
      this.loadingSubscriptions = true;
      const { id, userid } = this.$store.getters['session/user'];

      try {
        const response = await this.suscripcionesClient.addSubscriptionsAll({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        if (response.status && response.status === 200) {
          this.groupingsAppList.forEach((group) => {
            group.children.forEach((application) => {
              application.suscrito = true;
            });
          });

          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          this.sortApplicationsBySubscription();
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    async deleteSubscriptionsAll() {
      this.loadingSubscriptions = true;
      const { id, userid } = this.$store.getters['session/user'];

      try {
        const response = await this.suscripcionesClient.deleteSubscriptionsAll({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        if (response.status && response.status === 200) {
          this.groupingsAppList.forEach((group) => {
            group.children.forEach((application) => {
              application.suscrito = false;
            });
          });

          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          this.sortApplicationsBySubscription();
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },

    //
    clickAddGroup({ groupId, nombre }) {
      if (nombre === this.titleAllGroups) {
        this.addSubscriptionsAll();
      } else {
        this.addApplicationOrGroups({ uuidAgrupacion: groupId, nombre });
      }
    },
    clickDeleteGroup({ groupId, nombre }) {
      if (nombre === this.titleAllGroups) {
        this.deleteSubscriptionsAll();
      } else {
        this.deleteApplicationOrGroups({ uuidAgrupacion: groupId, nombre });
      }
    },
    clickSwitchActivateApplication({
      groupId,
      applicationId,
      nombre,
      isSubscriber,
    }) {
      if (!isSubscriber) {
        this.deleteApplicationOrGroups({
          uuidAgrupacion: groupId,
          uuidAplicacion: applicationId,
          nombre,
        });
      } else {
        this.addApplicationOrGroups({
          uuidAgrupacion: groupId,
          uuidAplicacion: applicationId,
          nombre,
        });
      }
    },

    //
    async deleteApplicationOrGroups({ uuidAgrupacion, uuidAplicacion, nombre }) {
      const { id, userid } = this.$store.getters['session/user'];
      const status = false;

      // Si no viene el uuidAplicacion la accion ha sido por agrupacion
      if (!uuidAplicacion) {
        this.loadingSubscriptions = true;
      }

      try {
        const response = await this.suscripcionesClient.deleteApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/suscripciones/agrupaciones',
          },
          uuidAgrupacion,
          uuidAplicacion,
        });

        if (response.status === 200) {
          if (!uuidAplicacion) {
            this.updateStatusGroups({
              uuidAgrupacion,
              nombre,
              status,
            });
          } else {
            this.updateStatusApplication({
              uuidAgrupacion,
              uuidAplicacion,
              nombre,
              status,
            });
          }
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    async addApplicationOrGroups({ uuidAgrupacion, uuidAplicacion, nombre }) {
      const { id, userid } = this.$store.getters['session/user'];
      const status = true;

      // Si no viene el uuidAplicacion la accion ha sido por agrupacion
      if (!uuidAplicacion) {
        this.loadingSubscriptions = true;
      }

      try {
        const response = await this.suscripcionesClient.addApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/suscripciones/agrupaciones',
          },
          uuidAgrupacion,
          uuidAplicacion,
        });

        if (response.status === 200) {
          if (!uuidAplicacion) {
            this.updateStatusGroups({
              uuidAgrupacion,
              nombre,
              status,
            });
          } else {
            this.updateStatusApplication({
              uuidAgrupacion,
              uuidAplicacion,
              nombre,
              status,
            });
          }
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        if (this.isLinkBanner) {
          this.loadingSubscriptions = true;
        } else {
          this.loadingSubscriptions = false;
        }
      }
    },

    //
    async getApplications() {
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscripcionesClient.getApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        const { collection_subscriptions: collectionSubscriptions } = response;
        return collectionSubscriptions;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async getGroups() {
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscripcionesClient.getGroups({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones',
          },
        });

        const { collection_subscriptions: collectionSubscriptions } = response;
        return collectionSubscriptions;
      } catch (error) {
        console.log(error);
      }
      return null;
    },

    //
    updateStatusApplication({
      uuidAgrupacion,
      uuidAplicacion,
      nombre,
      status,
    }) {
      this.groupingsAppList.forEach((group) => {
        if (group.nombre === this.titleAllGroups) {
          group.children.forEach((application) => {
            if (
              application.agrupacion.uuid === uuidAgrupacion
              && application.uuid === uuidAplicacion
            ) {
              application.suscrito = status;
            }
          });
        } else {
          group.children.forEach((application) => {
            if (
              application.agrupacion.uuid === uuidAgrupacion
              && application.uuid === uuidAplicacion
              && application.nombre === nombre
            ) {
              application.suscrito = status;
            }
          });
        }
      });
      this.sortApplicationsBySubscription();
    },
    updateStatusGroups({
      uuidAgrupacion,
      status,
    }) {
      this.groupingsAppList = this.groupingsAppList.map((group) => {
        group.children = group.children.map((child) => {
          if (child.agrupacion.uuid === uuidAgrupacion) {
            return {
              ...child,
              suscrito: status,
            };
          }
          return child;
        });
        return group;
      });

      this.sortApplicationsBySubscription();
    },
    sortApplicationsBySubscription() {
      this.groupingsAppList.forEach((group) => {
        group.children.sort((a, b) => b.suscrito - a.suscrito);
      });
      this.groupingsAppListAux = this.groupingsAppList;
    },
    getDataForSubscriptions({ applications, groupingsAppList }) {
      const resultado = [];

      groupingsAppList.children.forEach((child) => {
        if (applications.includes(child.uuid)) {
          const {
            nombre,
            uuid,
            suscrito,
            agrupacion,
          } = child;

          resultado.push({
            nameGroup: agrupacion.nombre,
            uuidGroup: agrupacion.uuid,
            nameAplication: nombre,
            uuidAplication: uuid,
            suscrito,
          });
        }
      });

      return resultado;
    },
    async suscriptionsApplications(applicationForsuscribir) {
      const promises = applicationForsuscribir.map((application) => {
        const {
          uuidGroup,
          nameAplication,
          uuidAplication,
          suscrito,
        } = application;

        if (!suscrito) {
          return this.addApplicationOrGroups({
            uuidAgrupacion: uuidGroup,
            uuidAplicacion: uuidAplication,
            nombre: nameAplication,
          });
        }

        return Promise.resolve();
      });

      await Promise.all(promises);
    },
  },

  async created() {
    this.suscripcionesClient = this.$api.getClient('suscripciones');
    this.isAppInstalled = await this.$api.getClient('userInfo').getAppInstalled();
    try {
      const [listApplicationsResponse, listGroupsResponse] = await Promise.all([
        this.getApplications(),
        this.getGroups(),
      ]);

      if (!listApplicationsResponse || !listGroupsResponse) {
        this.loadingSubscriptions = false;
        console.error('Error fetching data from services');
        return;
      }

      const { applications: applicationsList } = listApplicationsResponse;
      const { groups: gropusList } = listGroupsResponse;

      const result = [];
      result.push({
        active: true,
        children: applicationsList,
        nombre: this.titleAllGroups,
        uuid: null,
      });

      gropusList.forEach((group) => {
        const children = applicationsList.filter((app) => app.agrupacion.uuid === group.uuid);

        const { nombre, uuid } = group;
        result.push({
          active: false,
          children,
          nombre,
          uuid,
        });
      });

      this.groupingsAppList = result;
      this.sortApplicationsBySubscription();

      this.filtersInitialMySubscription = this.groupingsAppList.map((item) => ({
        text: item.nombre,
        status: item.nombre,
        statusTrim: item.nombre.trim().replace(/\s+/g, ' '),
        groupId: item.uuid,
      }));
      this.filtersMySubscription = [this.titleAllGroups];

      if (this.applications && this.applications.length > 0) {
        this.isLinkBanner = true;
        const applicationsForSuyscription = this.getDataForSubscriptions({
          applications: this.applications,
          groupingsAppList: this.groupingsAppList[0],
        });

        await this.suscriptionsApplications(applicationsForSuyscription);
        this.isLinkBanner = false;
      }

      this.loadingSubscriptions = false;
    } catch (error) {
      console.error('Error creating groupings:', error);
      this.loadingSubscriptions = false;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    setInterval(() => {
      this.showFilters = true;
    }, 1000);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;
.v-menu__content{
    margin-top:2.5rem;
    box-shadow: none !important;
}
.listSheet{
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
     0px 8px 10px 1px rgba(0, 0, 0, 0.14),
     0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
}
.listSheetItem{
    display: block;
    min-height: 1rem;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.loadingProgress{
    height: 10rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
}
.notification--title {
    font-size: 1rem;
  }
  .textEllipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .selectCol {
    padding: 0;
  }
  .plantillaTree {
    background-color: white;
  }

  .plantillaSuscrip {
    background-color: white;
    /* padding: 1em 0em; */
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }

  .misSuscripciones {
    color: #27846d !important;
    caret-color: #27846d !important;
    background-color: #e1f2ee !important;
  }

  .sinEstilosMisSuscripciones {
    color: #000000 !important;
    background-color: #e0e0e0 !important;
  }

  .card {
    flex: 0 0 33.3333%;
  }
  .plantillaChips {
    background: transparent;
  }

  .container-apps {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .v-item-group .v-slide-group__wrapper .v-slide-group__content {
    display: flex!important;
    flex-wrap: wrap!important;
    width: 100%!important;
  }
  .container_form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 1rem;
  }

  .btn__suscripciones {
    margin-left: 2rem;
  }

  .chip__filter {
    padding: 0;
    padding-left: 15px;
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }

  .card__aplicacion {
    width: 100%;
  }
  .v-card__title{
    white-space: initial!important;
    word-break: inherit;
  }
  .msgErrorSuscripciones {
    margin-left: 1.5rem;
  }
  .chip__active {
    color: #27846d !important;
    background-color: #e6f1ee;
    border: 1px solid #27846d !important;
  }
  .msg__download {
    padding: 0;
    margin: 0 2rem;
  }
  .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: 1rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
  .iconChips{
  color:#27846d !important;
  }

  @media (max-width: 900px) {
    .facet_sidebar {
      display: none;
    }
    .card.v-card {
      flex: initial;
      flex-direction: column;
    }
    .v-card__title {
      padding: 1rem 1rem 0!important;
      font-size: .8rem !important;
    }
    .v-card__actions {
      height: 50px!important;
      padding: 1rem 1rem!important;
    }
    .chip__test > .v-slide-group__wrapper{
      background-color: red !important;
    }
    .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: .8rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 600px) {
    .btn__suscripciones {
      margin-left: 0;
    }
    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .titleMobile{
      margin-left: 2rem !important;
    }
  }

</style>
